var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"item-content"},_vm._l((_vm.tickets),function(ticket){return _c('Ticket',{key:ticket.id,attrs:{"ticket":ticket,"event_map":_vm.event_map,"interest_mode":_vm.interest_mode}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }